module.exports = __webpack_public_path__ + "static/media/DATALIFE-LOGO-INFO.7b239a04.png";